import React from 'react';
import Table from 'react-material-table';

const OrderHistory = () => {
  const [orders, setOrders] = React.useState([]);

  const fetchData = () => {
    setOrders([
      {
        date: "1/1/20",
        time: "20:20:00",
        cart: "Test Episode, Another episode",
        amount: 200,
      },
      {
        date: "2/2/20",
        time: "30:30:00",
        cart: "Prologue, Epilogue",
        amount: 500,
      }
    ]);
  };

  const columns = [
    {
      title: "Date",
      dataName: "date"
    },
    {
      title: "Time",
      dataName: "time"
    },
    {
      title: "Cart",
      dataName: "cart"
    },
    {
      title: "Amount",
      dataName: "amount"
    },
  ];

  React.useEffect(() => {
    fetchData();
  }, []);

  if (orders.length !== 0) {
    return (
      <div style={{ marginTop: 60, width: '60%', marginLeft: 'auto', marginRight: 'auto', }}>
        <h3>Orders</h3>
        <Table data={orders} columns={columns} />
      </div>
    );
  }

  return (
    <div>
      <h2>Order Details</h2>
      <h5>No Orders found</h5>
    </div>
  );
};

export default OrderHistory;